// Libraries
import { Box, Flex, Radio, Text, Tooltip } from "@chakra-ui/react";
import React, { Fragment } from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
// Recoil
import { useRecoilState } from "recoil";
import { filterData } from "../../State";
// COmponents
import SideBottomLinks from "../UI/Navbar/SideBottomLinks";

const Filter: React.FC<{ pl?: number; pr?: number; industries?: any }> = ({ pl, pr, industries }) => {
  const [show, setShow] = React.useState(true);

  // Recoil
  // const AllIndustries = useRecoilValue(IndustryList);
  const AllIndustries = industries.filter((item, index) => {
    return industries.indexOf(item) === index;
  });

  const [filterBy, setFilterData] = useRecoilState(filterData);

  const handleToggle = () => setShow(!show);

  return (
    <Fragment>
      <Flex h="100%" w="100%" pl={pl} pr={pr} flexDir="column">
        {/* Collapse */}
        <Box
          mb={20}
          w="100%"
          // height="400px"
          overflowY="auto"
          overflowX="hidden">
          <Flex
            cursor="pointer"
            justifyContent="space-between"
            onClick={handleToggle}
            fontSize="sm"
            color="gray.500"
            fontWeight={700}
            w="100%">
            <Text my="auto">Categories</Text>

            {/* Collapse icon */}
            <Text my="auto" fontSize="xl" pr={4}>
              {show ? <HiChevronUp /> : <HiChevronDown />}
            </Text>
          </Flex>

          {show && (
            <Box w="100%" pl={1} fontWeight="bold" fontSize="md" color="gray.500" mt={6}>
              {/* <RadioGroup onChange={(value) => setFilterData(value)}> */}

              <Radio
                cursor="pointer"
                isChecked={filterBy.value === "All"}
                onChange={(e) => {
                  setFilterData({
                    value: e.target.value,
                    checked: e.target.checked,
                  });
                }}
                value="All"
                mb={4}
                w="100%">
                All
              </Radio>

              {AllIndustries.map((industry) => {
                if (industry) {
                  return (
                    <Box w="100%">
                      <Radio
                        w="100%"
                        cursor="pointer"
                        isChecked={filterBy.value === industry}
                        onChange={(e) => {
                          setFilterData({
                            value: e.target.value,
                            checked: e.target.checked,
                          });
                        }}
                        value={industry}
                        mb={4}>
                        <Tooltip label={industry} aria-label="industry">
                          <Text w="100%" as="span" isTruncated>
                            {/* {industry} */}
                            {industry && industry.length > 22 ? <>{industry && industry.slice(0, 22)}...</> : <>{industry}</>}
                          </Text>
                        </Tooltip>
                      </Radio>
                    </Box>
                  );
                }
              })}

              {/* </RadioGroup> */}

              {/* <RadioGroup onChange={(value) => console.log(value)}>
							{AllIndustries.map(industry => {
								return (
									<Box>
										<Radio value={industry} mb={4}>
											{industry}
										</Radio>
									</Box>
								);
							})}


						</RadioGroup> */}
            </Box>
          )}
        </Box>

        {/* SIde links */}
        <Box mt="auto">
          <SideBottomLinks />
        </Box>
      </Flex>
    </Fragment>
  );
};

export default Filter;
